import React from "react";
import PropTypes from "prop-types";
import { css } from "@emotion/react";
import { breakpoints } from "~styles/global";
import Figure from "~components/modules/Figure";
import RichText from "~components/RichText";

const ImageAndTextModuleForArticle = ({ className, content }) => {
  const { mobile } = breakpoints;
  const reverse = content?.layout === "imageRight";

  return (
    <div
      className={className}
      css={css`
        display: grid;
        grid-template-columns: repeat(12, 1fr);
        grid-column-gap: 20px;
        max-width: 1500px;
        margin-left: auto;
        margin-right: auto;
        padding: 0 40px;
        ${mobile} {
          grid-column-gap: 10px;
          padding: 0 25px;
        }
      `}
    >
      <div
        css={css`
          grid-column: ${reverse ? `7/12` : `2/7`};
          grid-row: 1;
          ${mobile} {
            grid-column: span 12;
            grid-row: 1;
            margin-bottom: 50px;
          }
        `}
      >
        <Figure image={content?.image?.asset?.id} caption={content?.caption} />
      </div>
      <div
        css={css`
          grid-column: ${reverse ? `2/6` : `8/12`};
          grid-row: 1;
          ${mobile} {
            grid-column: span 12;
            grid-row: 2;
          }
          display: flex;
          align-items: ${content?.verticalAlign === "top" ? "flex-start" : "center"};
        `}
      >
        <RichText content={content?.text} />
      </div>
    </div>
  );
};

ImageAndTextModuleForArticle.propTypes = {
  imageLeft: PropTypes.string,
  imageRight: PropTypes.string,
  captionLeft: PropTypes.array,
  captionRight: PropTypes.array,
};

ImageAndTextModuleForArticle.defaultProps = {
  captionLeft: [],
  captionRight: [],
};

export default ImageAndTextModuleForArticle;
